import React, { Component } from 'react';
import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";
import SectionPlainTitle from "../../Common/components/SectionPlainTitle";
import MoreNews from "../../News/containers/MoreNews";
import MostReadRacing from "../../Common/containers/MostReadRacing";

export default class HorseRacingRichardFaheyPage extends Component {
  render() {
    const { location } = this.props;

    return (
      <StandardPage sport="racing" title="Richard Fahey - Columnists" >
        <div className="main-layout-left-column">
          <div className="main-layout-block">
            <SectionPlainTitle className="page-main-section-title" level={1}>Richard Fahey</SectionPlainTitle>
          </div>
          <div id="left-most-read" className="main-layout-block last-desktop">
            <MoreNews location={location} />
          </div>
          <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
            <MostReadRacing location={location} plainTitle />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["mostReadRacing", "topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingRichardFaheyPage.js